// deps
import { defineMessage } from "react-intl";

// Type de service

/** Draps lit double */
export const HOTEL_SERVICE_TYPE_VALUE_DOUBLE_BED_LINEN = "double_bed_linen";
/** Draps lit simple */
export const HOTEL_SERVICE_TYPE_VALUE_SINGLE_BED_LINEN = "single_bed_linen";
/** Kit linge de lit complet */
export const HOTEL_SERVICE_TYPE_VALUE_COMPLETE_BED_LINEN = "complete_bed_linen";
/** Linge de maison */
export const HOTEL_SERVICE_TYPE_VALUE_HOUSE_LINEN = "house_linen";
/** Linge de toilette */
export const HOTEL_SERVICE_TYPE_VALUE_BATHROOM_LINEN = "bathroom_linen";
/** Kit linge complet */
export const HOTEL_SERVICE_TYPE_VALUE_COMPLETE_LINEN = "complete_linen";
/** Ménage fin de séjour */
export const HOTEL_SERVICE_TYPE_VALUE_CLEANING = "cleaning";
/** Location salle */
export const HOTEL_SERVICE_TYPE_VALUE_ROOM_RENTAL = "room_rental";
/** Supplément animaux */
export const HOTEL_SERVICE_TYPE_VALUE_PETS = "pets";
/** Bois de chauffage */
export const HOTEL_SERVICE_TYPE_VALUE_FIREWOOD = "firewood";
/** Forfait chauffage */
export const HOTEL_SERVICE_TYPE_VALUE_HEATING_PACKAGE = "heating_package";
/** Personne supplémentaire */
export const HOTEL_SERVICE_TYPE_VALUE_EXTRA_PERSON = "extra_person";
/** Location de matériel bébé */
export const HOTEL_SERVICE_TYPE_VALUE_BABY_EQUIPMENT_RENTAL =
  "baby_equipment_rental";
/** Table d’hôte */
export const HOTEL_SERVICE_TYPE_VALUE_GUEST_TABLE = "guest_table";
/** Recharge électrique */
export const HOTEL_SERVICE_TYPE_VALUE_ELECTRIC_RECHARGE = "electric_recharge";
/** Autre */
export const HOTEL_SERVICE_TYPE_VALUE_OTHER = "other";

export const HOTEL_SERVICE_TYPES = {
  [HOTEL_SERVICE_TYPE_VALUE_DOUBLE_BED_LINEN]: {
    id: HOTEL_SERVICE_TYPE_VALUE_DOUBLE_BED_LINEN,
    label: "draps lit double",
    description: "Draps pour un lit deux personnes",
  },
  [HOTEL_SERVICE_TYPE_VALUE_SINGLE_BED_LINEN]: {
    id: HOTEL_SERVICE_TYPE_VALUE_SINGLE_BED_LINEN,
    label: "draps lit simple",
    description: "Draps pour un lit une personne",
  },
  [HOTEL_SERVICE_TYPE_VALUE_COMPLETE_BED_LINEN]: {
    id: HOTEL_SERVICE_TYPE_VALUE_COMPLETE_BED_LINEN,
    label: "kit linge de lit complet",
    description: "Kit complet de linge de lit",
  },
  [HOTEL_SERVICE_TYPE_VALUE_HOUSE_LINEN]: {
    id: HOTEL_SERVICE_TYPE_VALUE_HOUSE_LINEN,
    label: "linge de maison",
    description: "Linge de maison",
  },
  [HOTEL_SERVICE_TYPE_VALUE_BATHROOM_LINEN]: {
    id: HOTEL_SERVICE_TYPE_VALUE_BATHROOM_LINEN,
    label: "linge de toilette",
    description: "Linge de toilette",
  },
  [HOTEL_SERVICE_TYPE_VALUE_COMPLETE_LINEN]: {
    id: HOTEL_SERVICE_TYPE_VALUE_COMPLETE_LINEN,
    label: "kit linge complet",
    description: "Kit complet de linge",
  },
  [HOTEL_SERVICE_TYPE_VALUE_CLEANING]: {
    id: HOTEL_SERVICE_TYPE_VALUE_CLEANING,
    label: "ménage de fin de séjour",
    description: "Ménage de fin de séjour",
  },
  [HOTEL_SERVICE_TYPE_VALUE_ROOM_RENTAL]: {
    id: HOTEL_SERVICE_TYPE_VALUE_ROOM_RENTAL,
    label: "location salle",
    description: "Location de salle",
  },
  [HOTEL_SERVICE_TYPE_VALUE_PETS]: {
    id: HOTEL_SERVICE_TYPE_VALUE_PETS,
    label: "supplément animaux",
    description: "Supplément pour les animaux",
  },
  [HOTEL_SERVICE_TYPE_VALUE_FIREWOOD]: {
    id: HOTEL_SERVICE_TYPE_VALUE_FIREWOOD,
    label: "bois de chauffage",
    description: "Bois de chauffage",
  },
  [HOTEL_SERVICE_TYPE_VALUE_HEATING_PACKAGE]: {
    id: HOTEL_SERVICE_TYPE_VALUE_HEATING_PACKAGE,
    label: "forfait chauffage",
    description: "Forfait chauffage",
  },
  [HOTEL_SERVICE_TYPE_VALUE_EXTRA_PERSON]: {
    id: HOTEL_SERVICE_TYPE_VALUE_EXTRA_PERSON,
    label: "personne supplémentaire",
    description: "Personne supplémentaire",
  },
  [HOTEL_SERVICE_TYPE_VALUE_BABY_EQUIPMENT_RENTAL]: {
    id: HOTEL_SERVICE_TYPE_VALUE_BABY_EQUIPMENT_RENTAL,
    label: "location de matériel bébé",
    description: "Location de matériel bébé",
  },
  [HOTEL_SERVICE_TYPE_VALUE_GUEST_TABLE]: {
    id: HOTEL_SERVICE_TYPE_VALUE_GUEST_TABLE,
    label: "table d’hôte",
    description: "Table d’hôte",
  },
  [HOTEL_SERVICE_TYPE_VALUE_ELECTRIC_RECHARGE]: {
    id: HOTEL_SERVICE_TYPE_VALUE_ELECTRIC_RECHARGE,
    label: "recharge électrique",
    description: "Point de recharge électrique",
  },
  [HOTEL_SERVICE_TYPE_VALUE_OTHER]: {
    id: HOTEL_SERVICE_TYPE_VALUE_OTHER,
    label: "autre",
    description: "Autre",
  },
};

export const HOTEL_SERVICE_TYPE_INTL_MESSAGES = {
  select: defineMessage({
    defaultMessage:
      "{hotelServiceType, select, double_bed_linen {draps lit double} single_bed_linen {draps lit simple} complete_bed_linen {kit linge de lit complet} house_linen {linge de maison} bathroom_linen {linge de toilette} complete_linen {kit linge complet} cleaning {ménage fin de séjour} room_rental {location salle} pets {supplément animaux} firewood {bois de chauffage} heating_package {forfait chauffage} extra_person {personne supplémentaire} baby_equipment_rental {location de matériel bébé} other {autre}}",
  }),
  byValue: {
    [HOTEL_SERVICE_TYPE_VALUE_DOUBLE_BED_LINEN]: {
      label: defineMessage({
        defaultMessage: "draps lit double",
        description: "Type de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_TYPE_VALUE_SINGLE_BED_LINEN]: {
      label: defineMessage({
        defaultMessage: "draps lit simple",
        description: "Type de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_TYPE_VALUE_COMPLETE_BED_LINEN]: {
      label: defineMessage({
        defaultMessage: "kit linge de lit complet",
        description: "Type de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_TYPE_VALUE_HOUSE_LINEN]: {
      label: defineMessage({
        defaultMessage: "linge de maison",
        description: "Type de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_TYPE_VALUE_BATHROOM_LINEN]: {
      label: defineMessage({
        defaultMessage: "linge de toilette",
        description: "Type de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_TYPE_VALUE_COMPLETE_LINEN]: {
      label: defineMessage({
        defaultMessage: "kit linge complet",
        description: "Type de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_TYPE_VALUE_CLEANING]: {
      label: defineMessage({
        defaultMessage: "ménage de fin de séjour",
        description: "Type de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_TYPE_VALUE_ROOM_RENTAL]: {
      label: defineMessage({
        defaultMessage: "location salle",
        description: "Type de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_TYPE_VALUE_PETS]: {
      label: defineMessage({
        defaultMessage: "supplément animaux",
        description: "Type de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_TYPE_VALUE_FIREWOOD]: {
      label: defineMessage({
        defaultMessage: "bois de chauffage",
        description: "Type de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_TYPE_VALUE_HEATING_PACKAGE]: {
      label: defineMessage({
        defaultMessage: "forfait chauffage",
        description: "Type de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_TYPE_VALUE_EXTRA_PERSON]: {
      label: defineMessage({
        defaultMessage: "personne supplémentaire",
        description: "Type de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_TYPE_VALUE_BABY_EQUIPMENT_RENTAL]: {
      label: defineMessage({
        defaultMessage: "location de matériel bébé",
        description: "Type de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_TYPE_VALUE_GUEST_TABLE]: {
      label: defineMessage({
        defaultMessage: "table d’hôte",
        description: "Type de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_TYPE_VALUE_ELECTRIC_RECHARGE]: {
      label: defineMessage({
        defaultMessage: "recharge électrique",
        description: "Type de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_TYPE_VALUE_OTHER]: {
      label: defineMessage({
        defaultMessage: "autre",
        description: "Type de service supplémentaire",
      }),
    },
  },
};

export const HOTEL_SERVICE_TYPE_LIST = Object.values(HOTEL_SERVICE_TYPES);

// Méthode de facturation

/** Facturation par adulte par nuit */
export const HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_NIGHT =
  "per_adult_per_night";
/** Facturation par adulte par jour */
export const HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_DAY =
  "per_adult_per_day";
/** Facturation par adulte par séjour */
export const HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_TRIP =
  "per_adult_per_trip";
/** Facturation par nuit */
export const HOTEL_SERVICE_STRATEGY_VALUE_PER_NIGHT = "per_night";
/** Facturation par jour */
export const HOTEL_SERVICE_STRATEGY_VALUE_PER_DAY = "per_day";
/** Facturation par séjour */
export const HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP = "per_trip";
/** Facturation par personne par nuit */
export const HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_NIGHT =
  "per_person_per_night";
/** Facturation par personne par jour */
export const HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_DAY =
  "per_person_per_day";
/** Facturation par personne par séjour */
export const HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_TRIP =
  "per_person_per_trip";
/** Facturation par animal par nuit */
export const HOTEL_SERVICE_STRATEGY_VALUE_PER_PET_PER_NIGHT =
  "per_pet_per_night";
/** Facturation par animal par jour */
export const HOTEL_SERVICE_STRATEGY_VALUE_PER_PET_PER_DAY = "per_pet_per_day";
/** Facturation par animal par séjour */
export const HOTEL_SERVICE_STRATEGY_VALUE_PER_PET_PER_TRIP = "per_pet_per_trip";
/** Facturation par lit 1 personne par nuit */
export const HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_NIGHT =
  "per_single_bed_per_night";
/** Facturation par lit 1 personne par jour */
export const HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_DAY =
  "per_single_bed_per_day";
/** Facturation par lit 1 personne par séjour */
export const HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_TRIP =
  "per_single_bed_per_trip";
/** Facturation par lit 2 personnes par nuit */
export const HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_NIGHT =
  "per_double_bed_per_night";
/** Facturation par lit 2 personnes par jour */
export const HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_DAY =
  "per_double_bed_per_day";
/** Facturation par lit 2 personnes par séjour */
export const HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_TRIP =
  "per_double_bed_per_trip";
/** Quantité libre */
export const HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY = "free_quantity";

export const HOTEL_SERVICE_STRATEGIES = {
  [HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_NIGHT]: {
    id: HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_NIGHT,
    label: "par adulte par nuit",
  },
  [HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_DAY]: {
    id: HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_DAY,
    label: "par adulte par jour",
  },
  [HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_TRIP]: {
    id: HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_TRIP,
    label: "par adulte",
  },
  [HOTEL_SERVICE_STRATEGY_VALUE_PER_NIGHT]: {
    id: HOTEL_SERVICE_STRATEGY_VALUE_PER_NIGHT,
    label: "par nuit",
  },
  [HOTEL_SERVICE_STRATEGY_VALUE_PER_DAY]: {
    id: HOTEL_SERVICE_STRATEGY_VALUE_PER_DAY,
    label: "par jour",
  },
  [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: {
    id: HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP,
    label: "par séjour",
  },
  [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_NIGHT]: {
    id: HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_NIGHT,
    label: "par personne par nuit",
  },
  [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_DAY]: {
    id: HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_DAY,
    label: "par personne par jour",
  },
  [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_TRIP]: {
    id: HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_TRIP,
    label: "par personne",
  },
  [HOTEL_SERVICE_STRATEGY_VALUE_PER_PET_PER_NIGHT]: {
    id: HOTEL_SERVICE_STRATEGY_VALUE_PER_PET_PER_NIGHT,
    label: "par animal par nuit",
  },
  [HOTEL_SERVICE_STRATEGY_VALUE_PER_PET_PER_DAY]: {
    id: HOTEL_SERVICE_STRATEGY_VALUE_PER_PET_PER_DAY,
    label: "par animal par jour",
  },
  [HOTEL_SERVICE_STRATEGY_VALUE_PER_PET_PER_TRIP]: {
    id: HOTEL_SERVICE_STRATEGY_VALUE_PER_PET_PER_TRIP,
    label: "par animal par séjour",
  },
  [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_NIGHT]: {
    id: HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_NIGHT,
    label: "par lit 1 personne par nuit",
  },
  [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_DAY]: {
    id: HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_DAY,
    label: "par lit 1 personne par jour",
  },
  [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_TRIP]: {
    id: HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_TRIP,
    label: "par lit 1 personne",
  },
  [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_NIGHT]: {
    id: HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_NIGHT,
    label: "par lit 2 personnes par nuit",
  },
  [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_DAY]: {
    id: HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_DAY,
    label: "par lit 2 personnes par jour",
  },
  [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_TRIP]: {
    id: HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_TRIP,
    label: "par lit 2 personnes",
  },
  [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: {
    id: HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY,
    label: "à l’unité",
  },
};

export const HOTEL_SERVICE_STRATEGY_INTL_MESSAGES = {
  select: defineMessage({
    defaultMessage:
      "{hotelServiceStrategy, select, per_adult_per_night {par adulte par nuit} per_adult_per_day {par adulte par jour} per_adult_per_trip {par adulte} per_night {par nuit} per_day {par jour} per_trip {par séjour} per_person_per_night {par personne par nuit} per_person_per_day {par personne par jour} per_person_per_trip {par personne} per_pet_per_night {par animal par nuit} per_pet_per_day {par animal par jour} per_pet_per_trip {par animal} per_single_bed_per_night {par lit 1 personne par nuit} per_single_bed_per_day {par lit 1 personne par jour} per_single_bed_per_trip {par lit 1 personne} per_double_bed_per_night {par lit 2 personnes par nuit} per_double_bed_per_day {par lit 2 personnes par jour} per_double_bed_per_trip {par lit 2 personnes} free_quantity {à l’unité} other {stratégie de facturation inconnue}}",
  }),
  byValue: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_NIGHT]: {
      label: defineMessage({
        defaultMessage: "par adulte par nuit",
        description: "Stratégie de facturation de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_DAY]: {
      label: defineMessage({
        defaultMessage: "par adulte par jour",
        description: "Stratégie de facturation de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_TRIP]: {
      label: defineMessage({
        defaultMessage: "par adulte",
        description: "Stratégie de facturation de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_NIGHT]: {
      label: defineMessage({
        defaultMessage: "par nuit",
        description: "Stratégie de facturation de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DAY]: {
      label: defineMessage({
        defaultMessage: "par jour",
        description: "Stratégie de facturation de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: {
      label: defineMessage({
        defaultMessage: "par séjour",
        description: "Stratégie de facturation de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_NIGHT]: {
      label: defineMessage({
        defaultMessage: "par personne par nuit",
        description: "Stratégie de facturation de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_DAY]: {
      label: defineMessage({
        defaultMessage: "par personne par jour",
        description: "Stratégie de facturation de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_TRIP]: {
      label: defineMessage({
        defaultMessage: "par personne",
        description: "Stratégie de facturation de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PET_PER_NIGHT]: {
      label: defineMessage({
        defaultMessage: "par animal par nuit",
        description: "Stratégie de facturation de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PET_PER_DAY]: {
      label: defineMessage({
        defaultMessage: "par animal par jour",
        description: "Stratégie de facturation de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PET_PER_TRIP]: {
      label: defineMessage({
        defaultMessage: "par animal par séjour",
        description: "Stratégie de facturation de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_NIGHT]: {
      label: defineMessage({
        defaultMessage: "par lit 1 personne par nuit",
        description: "Stratégie de facturation de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_DAY]: {
      label: defineMessage({
        defaultMessage: "par lit 1 personne par jour",
        description: "Stratégie de facturation de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_TRIP]: {
      label: defineMessage({
        defaultMessage: "par lit 1 personne",
        description: "Stratégie de facturation de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_NIGHT]: {
      label: defineMessage({
        defaultMessage: "par lit 2 personnes par nuit",
        description: "Stratégie de facturation de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_DAY]: {
      label: defineMessage({
        defaultMessage: "par lit 2 personnes par jour",
        description: "Stratégie de facturation de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_TRIP]: {
      label: defineMessage({
        defaultMessage: "par lit 2 personnes",
        description: "Stratégie de facturation de service supplémentaire",
      }),
    },
    [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: {
      label: defineMessage({
        defaultMessage: "à l’unité",
        description: "Stratégie de facturation de service supplémentaire",
      }),
    },
  },
};

/**
 * Liste des stratégies de facturation supportées en fonction du type de service
 */
export const HOTEL_SERVICE_STRATEGIES_SUPPORTED_BY_TYPE = {
  [HOTEL_SERVICE_TYPE_VALUE_DOUBLE_BED_LINEN]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: null,
  },
  [HOTEL_SERVICE_TYPE_VALUE_SINGLE_BED_LINEN]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: null,
  },
  [HOTEL_SERVICE_TYPE_VALUE_COMPLETE_BED_LINEN]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: null,
  },
  [HOTEL_SERVICE_TYPE_VALUE_HOUSE_LINEN]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: null,
  },
  [HOTEL_SERVICE_TYPE_VALUE_BATHROOM_LINEN]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: null,
  },
  [HOTEL_SERVICE_TYPE_VALUE_COMPLETE_LINEN]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: null,
  },
  [HOTEL_SERVICE_TYPE_VALUE_BABY_EQUIPMENT_RENTAL]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: null,
  },
  [HOTEL_SERVICE_TYPE_VALUE_CLEANING]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: null,
  },
  [HOTEL_SERVICE_TYPE_VALUE_FIREWOOD]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: null,
  },
  [HOTEL_SERVICE_TYPE_VALUE_HEATING_PACKAGE]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_SINGLE_BED_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_DOUBLE_BED_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: null,
  },
  [HOTEL_SERVICE_TYPE_VALUE_PETS]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PET_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PET_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PET_PER_TRIP]: null,
  },
  [HOTEL_SERVICE_TYPE_VALUE_EXTRA_PERSON]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: null,
  },
  [HOTEL_SERVICE_TYPE_VALUE_GUEST_TABLE]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_NIGHT]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_DAY]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_TRIP]: null,
    [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: null,
  },
};

export const HOTEL_SERVICE_STRATEGY_LIST = Object.values(
  HOTEL_SERVICE_STRATEGIES,
);

/**
 * Liste des stratégies de facturation supportées par le site national en fonction du type et de la stratégie de facturation
 */
export const HOTEL_SERVICE_TYPE_AND_STRATEGY_SUPPORTED_BY_SN_MAP = {
  [HOTEL_SERVICE_TYPE_VALUE_DOUBLE_BED_LINEN]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: true,
    [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: true,
  },
  [HOTEL_SERVICE_TYPE_VALUE_SINGLE_BED_LINEN]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: true,
    [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: true,
  },
  [HOTEL_SERVICE_TYPE_VALUE_COMPLETE_BED_LINEN]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: true,
    [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: true,
  },
  [HOTEL_SERVICE_TYPE_VALUE_HOUSE_LINEN]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: true,
    [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: true,
  },
  [HOTEL_SERVICE_TYPE_VALUE_BATHROOM_LINEN]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: true,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_TRIP]: true,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_TRIP]: true,
    [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: true,
  },
  [HOTEL_SERVICE_TYPE_VALUE_COMPLETE_LINEN]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: true,
  },
  [HOTEL_SERVICE_TYPE_VALUE_CLEANING]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: true,
  },
  [HOTEL_SERVICE_TYPE_VALUE_ROOM_RENTAL]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: true,
  },
  [HOTEL_SERVICE_TYPE_VALUE_PETS]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: true,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PET_PER_TRIP]: true,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_NIGHT]: true,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PET_PER_NIGHT]: true,
  },
  [HOTEL_SERVICE_TYPE_VALUE_FIREWOOD]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: true,
    [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: true,
  },
  [HOTEL_SERVICE_TYPE_VALUE_HEATING_PACKAGE]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: true,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_NIGHT]: true,
  },
  [HOTEL_SERVICE_TYPE_VALUE_EXTRA_PERSON]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: true,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_NIGHT]: true,
    [HOTEL_SERVICE_STRATEGY_VALUE_FREE_QUANTITY]: true,
  },
  [HOTEL_SERVICE_TYPE_VALUE_BABY_EQUIPMENT_RENTAL]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_TRIP]: true,
  },
  [HOTEL_SERVICE_TYPE_VALUE_GUEST_TABLE]: {
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_PERSON_PER_TRIP]: true,
    [HOTEL_SERVICE_STRATEGY_VALUE_PER_ADULT_PER_TRIP]: true,
  },
};

// Type de public concerné

/** Disponible pour les professionnels */
export const HOTEL_SERVICE_AVAILABLE_FOR_VALUE_PROFESSIONAL = "professional";
/** Disponible pour les particuliers */
export const HOTEL_SERVICE_AVAILABLE_FOR_VALUE_PARTICULAR = "particular";
/** Disponible pour tout le monde */
export const HOTEL_SERVICE_AVAILABLE_FOR_VALUE_ALL = "all";

export const HOTEL_SERVICE_AVAILABLE_FOR = {
  [HOTEL_SERVICE_AVAILABLE_FOR_VALUE_ALL]: {
    id: HOTEL_SERVICE_AVAILABLE_FOR_VALUE_ALL,
    label: "tout le monde",
    label2: "tout type de séjour",
    label3: "pour tout type de séjour",
    label4: "part. et pros.",
    description: "Ce service est disponible pour tout le monde",
  },
  [HOTEL_SERVICE_AVAILABLE_FOR_VALUE_PROFESSIONAL]: {
    id: HOTEL_SERVICE_AVAILABLE_FOR_VALUE_PROFESSIONAL,
    label: "professionnels",
    label2: "séjours professionnels",
    label3: "pour les séjours professionnels",
    label4: "professionnels",
    description: "Ce service est disponible pour les professionnels",
  },
  [HOTEL_SERVICE_AVAILABLE_FOR_VALUE_PARTICULAR]: {
    id: HOTEL_SERVICE_AVAILABLE_FOR_VALUE_PARTICULAR,
    label: "particuliers",
    label2: "séjours particuliers",
    label3: "pour les particuliers",
    label4: "particuliers.",
    description: "Ce service est disponible pour les particuliers",
  },
};

export const HOTEL_SERVICE_AVAILABLE_FOR_LIST = Object.values(
  HOTEL_SERVICE_AVAILABLE_FOR,
);

/** Non requis */
export const HOTEL_SERVICE_REQUIRED_FOR_VALUE_NONE = "none";
/** Requis pour tout le monde */
export const HOTEL_SERVICE_REQUIRED_FOR_VALUE_ALL = "all";
/** Requis pour les professionnels */
export const HOTEL_SERVICE_REQUIRED_FOR_VALUE_PROFESSIONAL = "professional";

export const HOTEL_SERVICE_REQUIRED_FOR = {
  [HOTEL_SERVICE_REQUIRED_FOR_VALUE_NONE]: {
    id: HOTEL_SERVICE_REQUIRED_FOR_VALUE_NONE,
    label: "non requis",
    label2: "pour personne",
    label3: "optionnel",
    label4: "optionnel",
    description: "Ce service n’est pas requis",
  },
  [HOTEL_SERVICE_REQUIRED_FOR_VALUE_ALL]: {
    id: HOTEL_SERVICE_REQUIRED_FOR_VALUE_ALL,
    label: "requis sur tous les contrats",
    label2: "pour tous les contrats",
    label4: "requis",
    description: "Tous les contrats doivent souscrire à ce service",
  },
  [HOTEL_SERVICE_REQUIRED_FOR_VALUE_PROFESSIONAL]: {
    id: HOTEL_SERVICE_REQUIRED_FOR_VALUE_PROFESSIONAL,
    label: "requis pour les contrats professionnels",
    label2: "pour les contrats professionnels",
    label4: "requis pros.",
    description:
      "Les contrats professionnels sont obligés de souscrire à ce service",
  },
};

export const HOTEL_SERVICE_REQUIRED_FOR_LIST = Object.values(
  HOTEL_SERVICE_REQUIRED_FOR,
);
